import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui';
import { UploadFile } from '@app/components';
import { hasPermission } from '@app/helpers/permissions';

import { anexarCartaCorrecao, urlDownloadArquivo } from '@app/api/autorizacaoPagamento/autorizacao';

import './modal.css';

export interface PropsModalAnexarCartaCorrecao {
  arquivoAutorizacaoId: string;
  setUpdate: any;
}

const ModalAnexarCartaCorrecao = (props: PropsModalAnexarCartaCorrecao) => {
  const { arquivoAutorizacaoId, setUpdate } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const [fileCartaCorrecao, setFileCartaCorrecao] = useState([]);

  const handleSubmit = values => {
    anexarCartaCorrecao(values, arquivoAutorizacaoId).then(data => {
      setUpdate(null);
      setUpdate(true);
    });
  };

  return (
    <>
      <Tooltip title="Anexar Carta de Correção">
        <Button
          onClick={() => {
            setExibirModal(true);
            // CarregarDados();
          }}
          icon="files-add_file"
          name="btnAnexarCartaCorrecao"
        />
      </Tooltip>
      <Modal
        title="Anexar Carta de Correção"
        // className="chat-modal"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModal"
          onSubmit={handleSubmit}
          actions={[
            <Button
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton
              noIcon={true}
              type="primary"
              disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}>
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <FormTextArea name="justificativa" label="Justificativa" span={12} rows={4} maxLength={2000} />
            <UploadFile
              nameFormData={'fileCartaCorrecao'}
              label={'Carta de Correção'}
              hasFile={true}
              url={'fileCartaCorrecao' + '&fileName=' + fileCartaCorrecao}
            />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalAnexarCartaCorrecao;
